module.exports = __webpack_public_path__ + "img/tips-burger.bbe7d82a.svg";